import { render, staticRenderFns } from "./main.vue?vue&type=template&id=dd49858e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd49858e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd49858e')) {
      api.createRecord('dd49858e', component.options)
    } else {
      api.reload('dd49858e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=dd49858e&scoped=true", function () {
      api.rerender('dd49858e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/view/components/TabTools/main.vue"
export default component.exports